// extracted by mini-css-extract-plugin
export default {"component":"list_component__-pXF-"};